export default __webpack_public_path__ + "static/media/stretch3.1cfdb291.png";